window.addEventListener('load', () => {
    const downloadEmployeePrint = document.querySelectorAll('.mm-emp-item__print');
    const downloadEmployeeWeb = document.querySelectorAll('.mm-emp-item__web');
    const downloadLogo = document.querySelectorAll('.mm-logo-container__item__logo-container');
    const downloadAllLogo = document.querySelectorAll('.mm-logo-container__download');

    downloadEmployeePrint.forEach(element => downloadFilesOnClick(element));
    downloadEmployeeWeb.forEach(element => downloadFilesOnClick(element));
    downloadLogo.forEach(element => downloadFilesOnClick(element));
    downloadAllLogo.forEach(element => downloadAllLogoOnClick(element));
});

function downloadFilesOnClick(element) {
    element.addEventListener('click', event => {
        let fileUrls;
        fileUrls = element.dataset.fileUrls.split(',');
        if (fileUrls.length > 0) {
            fileUrls.forEach(fileUrl => {
                if (fileUrl && fileUrl.trim() !== "") {
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.download = fileUrl.split('/').pop();
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            });
        }
    });
}

function downloadAllLogoOnClick(element) {
    element.addEventListener('click', event => {
        let fileUrls = [];
        const downloadLinks = document.querySelectorAll('.mm-logo-container__item__logo-container');
        downloadLinks.forEach(link => {
            const fileUrl = link.dataset.fileUrls;
            if (fileUrl && fileUrl.trim() !== "") {
                fileUrls.push(fileUrl);
            }
        });

        if (fileUrls.length > 0) {
            const zip = new JSZip();
            const zipFolder = zip.folder("logo_files");
            const fetchPromises = fileUrls.map(fileUrl => {
                return fetch(fileUrl)
                    .then(response => response.blob())
                    .then(blob => {
                        const fileName = fileUrl.split('/').pop();
                        zipFolder.file(fileName, blob);
                    })
                    .catch(error => {
                        console.error(`Error fetching file: ${fileUrl}`, error);
                    });
            });

            Promise.all(fetchPromises)
                .then(() => {
                    zip.generateAsync({ type: "blob" })
                        .then(blob => {
                            const zipLink = document.createElement('a');
                            zipLink.href = URL.createObjectURL(blob);
                            zipLink.download = "logo_files.zip";
                            document.body.appendChild(zipLink);
                            zipLink.click();
                            document.body.removeChild(zipLink);
                        })
                        .catch(error => {
                            console.error('Error generating zip file', error);
                        });
                });
        }
    });
}